var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2B2E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59457 10.7033V7.40708H10.0277C11.4593 7.40708 11.8119 6.07227 11.8119 6.07227H8.05276C6.26851 6.07227 5.96588 7.40764 5.96588 7.40764H8.18382V12.3672C8.18382 12.3672 9.59457 11.9436 9.59457 10.7033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7222 13.2716C14.9867 11.9576 15.4716 10.1329 15.0165 8.38744C14.7764 7.47414 14.2944 6.64247 13.6215 5.97994C13.5608 5.92032 13.5 5.85957 13.4291 5.79994L13.3684 5.73975C13.3271 5.69998 13.2831 5.66314 13.2368 5.6295L13.1558 5.56932L13.0348 5.47932L12.9634 5.42869C12.9151 5.39707 12.868 5.36368 12.8222 5.32857L12.7305 5.26894C12.6927 5.24145 12.6522 5.21789 12.6096 5.19863L12.5184 5.13844C12.4779 5.11819 12.4374 5.08782 12.3969 5.06813L12.3058 5.0175C12.2653 4.99782 12.2248 4.97757 12.1742 4.95788L12.1433 4.94775C12.2546 5.03775 12.3654 5.13844 12.4667 5.23857C12.9282 5.69614 13.2945 6.24057 13.5445 6.84045C13.7944 7.44033 13.9231 8.08378 13.9231 8.73366C13.9231 9.38354 13.7944 10.027 13.5445 10.6269C13.2945 11.2267 12.9282 11.7712 12.4667 12.2288C9.99957 14.6756 5.99513 14.6756 3.52688 12.2288C3.43576 12.1388 3.35476 12.0488 3.26419 11.9588L3.19332 11.8783C3.14032 11.8167 3.08966 11.7531 3.04144 11.6876C3.35871 12.3098 3.77175 12.8783 4.26544 13.3723C6.84394 15.9294 11.0301 15.9294 13.6086 13.3723C13.6535 13.3474 13.6923 13.3134 13.7222 13.2716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85 12.5922C5.73746 12.5004 5.62934 12.4034 5.526 12.3014C5.06403 11.8434 4.69735 11.2984 4.44711 10.698C4.19687 10.0975 4.06803 9.45343 4.06803 8.80291C4.06803 8.15239 4.19687 7.50832 4.44711 6.90786C4.69735 6.30739 5.06403 5.76244 5.526 5.30444C7.99593 2.85532 12.0037 2.85532 14.4737 5.30444C14.6458 5.47544 14.8072 5.656 14.9591 5.84669C14.6415 5.22709 14.2283 4.66141 13.7346 4.17044C11.1538 1.6105 6.96318 1.6105 4.38243 4.17044C4.35206 4.20025 4.32168 4.24075 4.28118 4.27057C2.57062 6.05763 2.33775 8.72782 3.70462 10.7556C4.24125 11.5375 4.98937 12.19 5.85 12.5922Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTusd);
export default __webpack_public_path__ + "static/media/tusd.b24a64e9868359deee854a6edcaf0858.svg";
export { ForwardRef as ReactComponent };